<i18n>
{
	"en": {
		"failedToRemoveOrderTrip": "Failed to remove order from trip",
		"failedToRemoveOrderTransporter": "Failed to remove order from transporter",
		"orderRemovedFromTrip": "Order removed from trip",
		"orderRemovedFromTransporter": "Order removed from transporter",
		"tripHasBeenScheduledForEdi": "Trip {tripNumber} has been scheduled for EDI sending",
		"failedToFetch": "Failed to search for trips"
	},
	"no": {
		"failedToRemoveOrderTrip": "Kunne ikke fjerne ordren fra turen",
		"failedToRemoveOrderTransporter": "Kunne ikke fjerne oppdrag fra transportøren",
		"orderRemovedFromTrip": "Oppdrag fjernet fra turen",
		"orderRemovedFromTransporter": "Oppdrag fjernet fra transportøren",
		"tripHasBeenScheduledForEdi": "Tur har blitt planlagt for EDI sending | Tur har blitt planlagt for EDI sending | Tur {tripNumber} har blitt planlagt for EDI sending",
		"failedToFetch": "Kunne ikke søke etter turer"
	}
}
</i18n>
<template>
	<t-horizontal-panel :showRightPanel="true" style="position: relative; overflow: hidden;width:100%;box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);">
		<TripList
			style="flex: 1;"
			:filtersVisible="filtersVisible"

			:availableWidth="containerWidth - tripSearchFiltersWidth"

			@toggleFilters="toggleFilters(!filtersVisible)"
			@showAddToTrip="$emit('showAddToTrip', $event)"
			@showAddToTransporter="$emit('showAddToTransporter', $event)"
			@cargoInfoDelete="onRemoveOrders"
			@cargoInfoMove="$emit('showMoveLoadedOrder', $event)"
			@cargoInfoScheduleOrderEdi="onScheduleOrder"
			@cargoInfoUnscheduleOrderEdi="onUnscheduleOrder"
			@packageLabel="showSinglePackageLabel"
			@waybill="showSingleWaybill"
			@transportInstruction="showSingleTransportInstruction"
			@removeOrder="onRemoveOrders($event)"
			@sendTripOrdersOnEdi="onSendTripOrdersOnEdi"
			@removeOrderAndMerge="onRemoveOrders($event,true)"
			@search="performFetchTrips"
		/>

		<TripSearchFilters
			v-show="filtersVisible"
			ref="tripSearchFilters"
			slot="right"
			style="width:200px"
			@saveSearch="$emit('saveSearch')"
			@loadSavedSearch="$emit('loadSavedSearch',$event)"
			@toggleFilters="toggleFilters(!filtersVisible)"
		/>
		<ConfirmRemoveTripOrder
			:isShown="confirmRemoveTripOrderVisible"
			:trip="tripDetails"
			@close="toggleRemoveTripOrder(false)"
			@confirm="confirmRemoveOrdersFromTrip"
		/>
		<ConfirmRemoveTransporterOrder
			:isShown="confirmRemoveTransporterOrderVisible"
			@close="toggleRemoveTransporterOrder(false)"
			@confirm="confirmRemoveOrdersFromTransporter"
		/>
	</t-horizontal-panel>
</template>

<script>
import { mapDynamicState, mapDynamicActions } from '@/core/mapDynamic';
import TripSearchFilters from './TripSearchFilters.vue';
import TripList from './TripList.vue';
import ConfirmRemoveTripOrder from '@/modules/tripSearch/modals/ConfirmRemoveTripOrder';
import ConfirmRemoveTransporterOrder from '@/modules/tripSearch/modals/ConfirmRemoveTransporterOrder';
import moment from 'moment';

export default {
	name: 'TripSearchListMain',
	components: {
		TripSearchFilters,
		TripList,
		ConfirmRemoveTripOrder,
		ConfirmRemoveTransporterOrder
	},
	props: {
		containerWidth: Number,
	},
	inject: ['namespace'],
	data() {
		return {
			filtersVisible: true,
			confirmRemoveTripOrderVisible: false,
			confirmRemoveTransporterOrderVisible: false,
			ordersToRemove: null,
			mergeOrder: false,
			tripSearchFiltersResizeObserver: null,
			tripSearchFiltersWidth: null,
		};
	},
	computed: {
		...mapDynamicState('computedStoreNamespace',['tripDetails']),
		computedStoreNamespace() {
			return `loadPlanning/${this.namespace.id}/tripSearch`;
		},
		computedLoadPlanningNamespace() {
			return `loadPlanning/${this.namespace.id}`;
		},
		localStorageId() {
			return `loadPlanningList/${this.namespace.id}`;
		},
	},
	watch: {
		'namespace.id': {
			handler() {
				this.setDefaultFilterVisibility();
			},
			immediate: true
		}
	},
	mounted() {
		document.addEventListener('keyup', this.onKey, { passive: true, capture: true });

		this.$nextTick()
			.then( () => {
				this.setupTripSearchFiltersFiltersResizeObserver();
			});
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.onKey, { capture: true });
	},
	methods: {
		...mapDynamicActions('computedLoadPlanningNamespace',[
			'removeOrdersFromTrip',
			'removeOrdersFromTransporter',
			'unscheduleSubOrderForEdi',
			'scheduleSubOrderForEdi',
			'getWaybill',
			'getPackageLabel',
			'getTransportInstruction',
			'sendTripOnEdi'
		]),
		...mapDynamicActions('computedStoreNamespace', ['fetchTrips']),
		async performFetchTrips() {
			try {
				await this.fetchTrips();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
		setupTripSearchFiltersFiltersResizeObserver() {

			let element = this.$refs.tripSearchFilters.$el;

			this.tripSearchFiltersWidth = element.getBoundingClientRect().width;

			this.tripSearchFiltersResizeObserver = new ResizeObserver(() => {

				this.tripSearchFiltersWidth = element.getBoundingClientRect().width;
			});

			this.tripSearchFiltersResizeObserver.observe(element);
		},
		setDefaultFilterVisibility() {
			let tripFilterOpen = localStorage.getItem(`${this.localStorageId}/tripFilterVisible`);
			if (tripFilterOpen === null || tripFilterOpen === 'true')
				this.toggleFilters(true);
			else
				this.toggleFilters(false);
		},
		toggleFilters(value = true) {
			localStorage.setItem(`${this.localStorageId}/tripFilterVisible`, value);
			this.filtersVisible = value;
		},
		toggleRemoveTransporterOrder(value) {
			this.confirmRemoveTransporterOrderVisible = value;
		},
		toggleRemoveTripOrder(value) {
			this.confirmRemoveTripOrderVisible = value;
		},
		onScheduleOrder(obj) {
			this.scheduleSubOrderForEdi(obj);
		},
		onUnscheduleOrder(obj) {
			this.unscheduleSubOrderForEdi(obj);
		},
		onSendTripOrdersOnEdi() {
			this.sendTripOnEdi();
			this.$notify({
				type: 'success',
				title: this.$tc('tripHasBeenScheduledForEdi', this.tripDetails.tripNumber)
			});
		},
		onRemoveOrders(orders, merge = false) {
			if (!orders) return;
			if (Array.isArray(orders))
				this.ordersToRemove = orders;
			else
				this.ordersToRemove = [orders];
			this.mergeOrder = merge;
			if (this.tripDetails.type.internalCode === 'external') {
				let timeCheck = moment.utc().subtract(5,'minutes')
					.valueOf();
				let hasSentOrders = this.ordersToRemove.some(x => x.createdAt < timeCheck || x.sentStatus);
				if (hasSentOrders)
					this.toggleRemoveTransporterOrder(true);
				else
					this.confirmRemoveOrdersFromTransporter();
			} else {
				this.toggleRemoveTripOrder(true);
			}
		},
		confirmRemoveOrdersFromTrip() {
			try {
				this.removeOrdersFromTrip({ orders: this.ordersToRemove, merge: this.mergeOrder });
				this.$notify({
					type: 'success',
					title: `${this.$t('orderRemovedFromTrip')}`
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToRemoveOrderTrip')
				});
			}
		},
		confirmRemoveOrdersFromTransporter() {
			try {
				this.removeOrdersFromTransporter({ orders: this.ordersToRemove, merge: this.mergeOrder });
				this.$notify({
					type: 'success',
					title: `${this.$t('orderRemovedFromTransporter')}`
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToRemoveOrderTransporter')
				});
			}
		},
		showSingleWaybill(id) {
			this.getWaybill([id]);
		},
		showSinglePackageLabel(id) {
			this.getPackageLabel([id]);
		},
		showSingleTransportInstruction(idsObj) {
			this.getTransportInstruction([idsObj]);
		},
	}
};
</script>

<style lang="scss" scoped>
.trip-details {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	z-index: 10;
}
</style>
